export default {
  development: 'http://localhost:7070/service-graph',
  staging: 'https://soa.freska-staging.com/service-graph',
  production: 'https://api.freska.io/service-graph',
};
